import ReactHtmlParser from 'react-html-parser';

export default ({ html }: any = {}) => {
    return ReactHtmlParser(html);
};
